import { inject } from '@angular/core';
import type { CreateQueryOptions } from '@tanstack/angular-query-experimental';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { PaymentMethodsApiService } from '../api/payment-methods-api.service';
import type { PaymentMethodOption } from '../contracts/payment-method.contract';

export const PAYMENT_METHODS_OPTIONS_QUERY_KEY = ['payment-methods', 'options'] as const;

type PaymentMethodsOptionsQueryOverrides = Partial<
    Omit<CreateQueryOptions<PaymentMethodOption[]>, 'queryKey' | 'queryFn'>
>;

export function injectPaymentMethodsOptionsQuery(optionsFn?: () => PaymentMethodsOptionsQueryOverrides) {
    const api = inject(PaymentMethodsApiService);

    return injectQuery(() => ({
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 5 * 60 * 1000,
        queryKey: PAYMENT_METHODS_OPTIONS_QUERY_KEY,
        queryFn: () => lastValueFrom(api.getPaymentMethodsOptions()),
        ...optionsFn?.(),
    }));
}
